export default "https://cdn-static.gokick.com/assets/6a734ef49f9399dbf744c5b441c6b52a80c19f9a/images/gokick-home-thumb.d0805bfbe5c122bc4415664ec8f6d56b.png";